//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OccupationLocation from '@/components/freelancer/OccupationLocation'
import AvatarDisplay from '@/components/ui/AvatarDisplay'
import TaskTags from '~/components/tasks/TaskTags'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'FreelancersSearchItem',
  components: {
    AvatarDisplay,
    OccupationLocation,
    TaskTags
  },
  props: {
    freelancer: {
      type: Object,
      required: true
    },
    id: {
      // eslint-disable-next-line
      type: Number | String,
      default: null
    },
    /**
     * Array of skill IDs
     */
    skills: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      avatarOptions: {
        resize: {
          width: 100,
          height: 100
        },
        rotate: null
      }
    }
  },
  computed: {
    fullName () {
      return `${this.freelancer.firstName} ${this.freelancer.lastName}` || ''
    },

    visibilityBoostedStyle () {
      return this.freelancer.visibility > 0 ? 'visibility-boosted' : ''
    }
  }
}
